<script setup lang="ts">
import Skeleton from '@/shared/ui/Skeleton/index';

const isMobile: boolean = useIsMobile();
</script>

<template>
  <div :class="['time-section-skeleton', { _mobile: isMobile }]">
    <div class="time-section-skeleton__header">
      <Skeleton
        :class="['time-section-skeleton__header-top', { _mobile: isMobile }]"
        :width="isMobile ? '45px' : '100%'"
        :height="isMobile ? '45px' : '91px'"
      />
      <Skeleton width="100%" :height="isMobile ? '110px' : '45px'" />
    </div>
    <div class="time-section-skeleton__footer">
      <Skeleton width="100%" :height="isMobile ? '32px' : '100px'" />
      <Skeleton
        :class="['time-section-skeleton__button', { _mobile: isMobile }]"
        :width="isMobile ? '100%' : '240px'"
        height="45px"
      />
    </div>
  </div>
</template>

<style lang="less" scoped>
.time-section-skeleton {
  .flex-column(56px);
  .box-shadow();

  padding: @size-x5;

  &__header {
    .flex-column(@size-x5);
  }

  &__footer {
    .flex-column(56px);
    gap: @size-x5;
  }

  &__header-top._mobile {
    margin-left: auto;
  }

  &__button:not(._mobile) {
    margin-left: auto;
  }
}
</style>
